var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.drawerComponent)?_c(_vm.drawerComponent,{key:_vm.drawerKey,tag:"component",attrs:{"config":_vm.drawer,"label":_vm.name,"type":_vm.type},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }